/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as UploadRouteImport } from './routes/upload';
import { Route as AuditRouteImport } from './routes/audit';
import { Route as IndexRouteImport } from './routes/index';
import { Route as VerkoopfacturenIndexRouteImport } from './routes/verkoopfacturen.index';
import { Route as InkoopfacturenIndexRouteImport } from './routes/inkoopfacturen.index';
import { Route as DocumentsIndexRouteImport } from './routes/documents.index';
import { Route as VerkoopfacturenIdRouteImport } from './routes/verkoopfacturen.$id';
import { Route as InkoopfacturenIdRouteImport } from './routes/inkoopfacturen.$id';
import { Route as DocumentsIdRouteImport } from './routes/documents.$id';
import { Route as AdminM365RouteImport } from './routes/admin.m365';
import { Route as AdminEntitiesRouteImport } from './routes/admin.entities';
import { Route as AdminEntitiesCodeExactRouteImport } from './routes/admin.entities_.$code.exact';

const UploadRoute = UploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => rootRouteImport,
} as any);
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const VerkoopfacturenIndexRoute = VerkoopfacturenIndexRouteImport.update({
  id: '/verkoopfacturen/',
  path: '/verkoopfacturen/',
  getParentRoute: () => rootRouteImport,
} as any);
const InkoopfacturenIndexRoute = InkoopfacturenIndexRouteImport.update({
  id: '/inkoopfacturen/',
  path: '/inkoopfacturen/',
  getParentRoute: () => rootRouteImport,
} as any);
const DocumentsIndexRoute = DocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => rootRouteImport,
} as any);
const VerkoopfacturenIdRoute = VerkoopfacturenIdRouteImport.update({
  id: '/verkoopfacturen/$id',
  path: '/verkoopfacturen/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const InkoopfacturenIdRoute = InkoopfacturenIdRouteImport.update({
  id: '/inkoopfacturen/$id',
  path: '/inkoopfacturen/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const DocumentsIdRoute = DocumentsIdRouteImport.update({
  id: '/documents/$id',
  path: '/documents/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const AdminM365Route = AdminM365RouteImport.update({
  id: '/admin/m365',
  path: '/admin/m365',
  getParentRoute: () => rootRouteImport,
} as any);
const AdminEntitiesRoute = AdminEntitiesRouteImport.update({
  id: '/admin/entities',
  path: '/admin/entities',
  getParentRoute: () => rootRouteImport,
} as any);
const AdminEntitiesCodeExactRoute = AdminEntitiesCodeExactRouteImport.update({
  id: '/admin/entities_/$code/exact',
  path: '/admin/entities/$code/exact',
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/audit': typeof AuditRoute;
  '/upload': typeof UploadRoute;
  '/admin/entities': typeof AdminEntitiesRoute;
  '/admin/m365': typeof AdminM365Route;
  '/documents/$id': typeof DocumentsIdRoute;
  '/inkoopfacturen/$id': typeof InkoopfacturenIdRoute;
  '/verkoopfacturen/$id': typeof VerkoopfacturenIdRoute;
  '/documents/': typeof DocumentsIndexRoute;
  '/inkoopfacturen/': typeof InkoopfacturenIndexRoute;
  '/verkoopfacturen/': typeof VerkoopfacturenIndexRoute;
  '/admin/entities/$code/exact': typeof AdminEntitiesCodeExactRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/audit': typeof AuditRoute;
  '/upload': typeof UploadRoute;
  '/admin/entities': typeof AdminEntitiesRoute;
  '/admin/m365': typeof AdminM365Route;
  '/documents/$id': typeof DocumentsIdRoute;
  '/inkoopfacturen/$id': typeof InkoopfacturenIdRoute;
  '/verkoopfacturen/$id': typeof VerkoopfacturenIdRoute;
  '/documents': typeof DocumentsIndexRoute;
  '/inkoopfacturen': typeof InkoopfacturenIndexRoute;
  '/verkoopfacturen': typeof VerkoopfacturenIndexRoute;
  '/admin/entities/$code/exact': typeof AdminEntitiesCodeExactRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/audit': typeof AuditRoute;
  '/upload': typeof UploadRoute;
  '/admin/entities': typeof AdminEntitiesRoute;
  '/admin/m365': typeof AdminM365Route;
  '/documents/$id': typeof DocumentsIdRoute;
  '/inkoopfacturen/$id': typeof InkoopfacturenIdRoute;
  '/verkoopfacturen/$id': typeof VerkoopfacturenIdRoute;
  '/documents/': typeof DocumentsIndexRoute;
  '/inkoopfacturen/': typeof InkoopfacturenIndexRoute;
  '/verkoopfacturen/': typeof VerkoopfacturenIndexRoute;
  '/admin/entities_/$code/exact': typeof AdminEntitiesCodeExactRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/audit'
    | '/upload'
    | '/admin/entities'
    | '/admin/m365'
    | '/documents/$id'
    | '/inkoopfacturen/$id'
    | '/verkoopfacturen/$id'
    | '/documents/'
    | '/inkoopfacturen/'
    | '/verkoopfacturen/'
    | '/admin/entities/$code/exact';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/audit'
    | '/upload'
    | '/admin/entities'
    | '/admin/m365'
    | '/documents/$id'
    | '/inkoopfacturen/$id'
    | '/verkoopfacturen/$id'
    | '/documents'
    | '/inkoopfacturen'
    | '/verkoopfacturen'
    | '/admin/entities/$code/exact';
  id:
    | '__root__'
    | '/'
    | '/audit'
    | '/upload'
    | '/admin/entities'
    | '/admin/m365'
    | '/documents/$id'
    | '/inkoopfacturen/$id'
    | '/verkoopfacturen/$id'
    | '/documents/'
    | '/inkoopfacturen/'
    | '/verkoopfacturen/'
    | '/admin/entities_/$code/exact';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuditRoute: typeof AuditRoute;
  UploadRoute: typeof UploadRoute;
  AdminEntitiesRoute: typeof AdminEntitiesRoute;
  AdminM365Route: typeof AdminM365Route;
  DocumentsIdRoute: typeof DocumentsIdRoute;
  InkoopfacturenIdRoute: typeof InkoopfacturenIdRoute;
  VerkoopfacturenIdRoute: typeof VerkoopfacturenIdRoute;
  DocumentsIndexRoute: typeof DocumentsIndexRoute;
  InkoopfacturenIndexRoute: typeof InkoopfacturenIndexRoute;
  VerkoopfacturenIndexRoute: typeof VerkoopfacturenIndexRoute;
  AdminEntitiesCodeExactRoute: typeof AdminEntitiesCodeExactRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/upload': {
      id: '/upload';
      path: '/upload';
      fullPath: '/upload';
      preLoaderRoute: typeof UploadRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/audit': {
      id: '/audit';
      path: '/audit';
      fullPath: '/audit';
      preLoaderRoute: typeof AuditRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/verkoopfacturen/': {
      id: '/verkoopfacturen/';
      path: '/verkoopfacturen';
      fullPath: '/verkoopfacturen/';
      preLoaderRoute: typeof VerkoopfacturenIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/inkoopfacturen/': {
      id: '/inkoopfacturen/';
      path: '/inkoopfacturen';
      fullPath: '/inkoopfacturen/';
      preLoaderRoute: typeof InkoopfacturenIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/documents/': {
      id: '/documents/';
      path: '/documents';
      fullPath: '/documents/';
      preLoaderRoute: typeof DocumentsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/verkoopfacturen/$id': {
      id: '/verkoopfacturen/$id';
      path: '/verkoopfacturen/$id';
      fullPath: '/verkoopfacturen/$id';
      preLoaderRoute: typeof VerkoopfacturenIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/inkoopfacturen/$id': {
      id: '/inkoopfacturen/$id';
      path: '/inkoopfacturen/$id';
      fullPath: '/inkoopfacturen/$id';
      preLoaderRoute: typeof InkoopfacturenIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/documents/$id': {
      id: '/documents/$id';
      path: '/documents/$id';
      fullPath: '/documents/$id';
      preLoaderRoute: typeof DocumentsIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/admin/m365': {
      id: '/admin/m365';
      path: '/admin/m365';
      fullPath: '/admin/m365';
      preLoaderRoute: typeof AdminM365RouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/admin/entities': {
      id: '/admin/entities';
      path: '/admin/entities';
      fullPath: '/admin/entities';
      preLoaderRoute: typeof AdminEntitiesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/admin/entities_/$code/exact': {
      id: '/admin/entities_/$code/exact';
      path: '/admin/entities/$code/exact';
      fullPath: '/admin/entities/$code/exact';
      preLoaderRoute: typeof AdminEntitiesCodeExactRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuditRoute: AuditRoute,
  UploadRoute: UploadRoute,
  AdminEntitiesRoute: AdminEntitiesRoute,
  AdminM365Route: AdminM365Route,
  DocumentsIdRoute: DocumentsIdRoute,
  InkoopfacturenIdRoute: InkoopfacturenIdRoute,
  VerkoopfacturenIdRoute: VerkoopfacturenIdRoute,
  DocumentsIndexRoute: DocumentsIndexRoute,
  InkoopfacturenIndexRoute: InkoopfacturenIndexRoute,
  VerkoopfacturenIndexRoute: VerkoopfacturenIndexRoute,
  AdminEntitiesCodeExactRoute: AdminEntitiesCodeExactRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
